module.exports = __webpack_public_path__ + "img/tu02.58cc2790.png";